export const mediaTypeChecker = (photo) => {
  const mediaType = photo.slice(-3); 
  return mediaType === 'mp4';
};